export default "__VITE_ASSET__149cf425__"